import { render, staticRenderFns } from "./advancePaymentStatementDetail.vue?vue&type=template&id=97e96a8e"
import script from "./advancePaymentStatementDetail.vue?vue&type=script&lang=js"
export * from "./advancePaymentStatementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports